export const requestStatusTypes =  {
    IDLE: "IDLE",
    LOADING: "LOADING",
    SUCCEEDED: "SUCCEEDED",
    FAILED: "FAILED"
}
